import { IEnvironmentConfiguration } from '@GFTypes/GameStoreTypes/EnvironmentConfiguration';

export const ENVIRONMENT_CONFIGURATION_DEFAULTS: IEnvironmentConfiguration = {
    autoPlaySettings: {
        spinValues: [],
        useLossLimitSlider: false,
        lossLimitMinRange: 0,
        lossLimitMaxRange: 0,
        showAdvancedSettings: false
    },
    allowQuickStop: true,
    allowTurbo: true,
    forceSpinningSet: undefined
};
